import React from "react";
import { AvatarGroup as MUIAvatarGroup } from "@mui/material";
import styled from "styled-components";
import { sizes } from "./Avatar";

const styles = ({ size }) => `
  display: flex;
  align-items: center;
  .MuiAvatarGroup-avatar {
    height: ${sizes[size] ?? size}px;
    width: ${sizes[size] ?? size}px;
    font-size: ${(sizes[size] ?? size) / 2}px;
  }
`;

const StyledAvatarGroup = styled(MUIAvatarGroup)(styles);

const AvatarGroup = ({ max, children, size }) => {
  return <StyledAvatarGroup {...{ max, size }}>{children}</StyledAvatarGroup>;
};

export default AvatarGroup;
